import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs';

@Pipe({
  name: 'dateAdd',
})
export class DateAddPipe implements PipeTransform {
  transform(
    today: Date | string | string,
    addValue: number,
    addUnit: dayjs.ManipulateType,
    format: string
  ): string {
    return dayjs(today).add(addValue, addUnit).format(format);
  }
}
